<template>
    <div class="ion-page">
        <ion-header>
          <ion-toolbar class="mobile-header-toolbar">
            <ion-buttons v-slot: start>
              <ion-menu-button></ion-menu-button>
              <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
              <ion-title>Charger Setup</ion-title>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
         <ChargerSetup />
        </ion-content>
    </div>
</template>
<script>
import { defineComponent } from "vue";
import ChargerSetup from "@/components/admin/ChargerSetup.vue";

import { IonButtons, IonContent, IonHeader, IonMenuButton, IonTitle, IonToolbar, IonBackButton } from '@ionic/vue';

export default defineComponent({
  name:  'chargerSetup',
  components: {
    ChargerSetup, IonHeader, IonToolbar, IonButtons, IonMenuButton, IonTitle, IonContent, IonBackButton
  },
  data() {
    return {
    }
  },
  methods: {
    navigatePreviousPage() {
      this.$router.go(-1)
    },
  }
})
</script>